module.exports = __webpack_public_path__ + "assets/img/4_119.d93f3bc0.jpg";